// Contrato HTTP da jornada do cliente.
//
// Ainda não existe no backend: o front roda sobre mock (services/journey-source)
// e estes paths são o contrato acordado, materializado pelo mock. Quando as
// rotas subirem, `DEFAULT_SOURCE` vira 'http' e nada mais muda.
const BASE = '/v3/api/client-journey'

export const clientJourney = {
  /** @method GET → JourneyTemplate */
  activeTemplate: () => `${BASE}/templates/active`,

  /**
   * @method POST Projeção leve para a listagem.
   * body: { clientIds?: number[], filters?: {...} } → ClientJourneySummary[]
   * NOTA: POST e não GET com querystring: a lista tem mais de mil clientes e a URL
   * estouraria.
   */
  searchClients: () => `${BASE}/clients/search`,

  /** @method GET → ClientJourney (completa, com steps) */
  clientJourney: (clientId) => `${BASE}/clients/${clientId}`,

  /**
   * @method POST body: { done, note? } → ClientJourney já re-resolvida.
   * Devolve a jornada inteira para o front não ter que recalcular qual virou a
   * etapa atual depois de concluir um passo.
   */
  markStep: (clientId, stepId) => `${BASE}/clients/${clientId}/steps/${stepId}`,

  /**
   * @method GET → ClientJourneyOverview
   * Os três cards do topo do resumo (dados, patrimônio, reuniões). Rota própria
   * porque o resumo 360 tem cadência de atualização diferente da jornada — e
   * porque a listagem, que só precisa do resumo leve, não deve pagar por ele.
   */
  clientOverview: (clientId) => `${BASE}/clients/${clientId}/overview`,

  /** @method GET → JourneyIndicators */
  indicators: () => `${BASE}/indicators`,
}
